"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

export const PushBlockContainerComponent: RegisteredComponent = {
  name: "PushBlockContainer",
  component: dynamic(
    async () => (await import("./PushBlockContainer")).PushBlockContainer
  ),
  canHaveChildren: true,

  childRequirements: {
    message: "You can only put PushBlock inside this component",
    query: {
      "component.name": {
        $in: ["PushBlock"],
      },
    },
  },
};
